import React, { useState } from 'react';

// Contact Info Component
const ContactInfo = () => {
  return (
    <div className="contact-info bg-white">
      <div className="contact-info-title text-center mb-4 px-5">
        <h3 className="mb-1">INFORMATION ABOUT US</h3>
        <p className="mb-0">Anand Krushi Parytan </p>
      </div>
      <div className="contact-info-content row mb-1">
     
        <ContactInfoItem
          icon="fa-phone"
          title="Phone Number"
          content={(
            <>
              <p className="m-0">+91 9689125047</p>
              <p className="m-0">+91 9623755047</p>
              <p className="m-0">+91 9673132497</p>
            </>
          )}
        />
        <ContactInfoItem
          icon="fa-envelope"
          title="Email Address"
          content={<a href="mailto:thopatemala@gmail.com" style={{ fontSize: '18px' }}><b>thopatemala@gmail.com</b></a>}
        />
           <ContactInfoItem
          icon="fa-map-marker-alt"
          title="Resort Location"
          content="Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218"
        />
      </div>
    </div>
  );
};

// Contact Info Item Component
const ContactInfoItem = ({ icon, title, content }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="info-item bg-lgrey px-4 py-5 border-all text-center rounded">
        <div className="info-icon mb-2">
          <i className={`fa ${icon} theme`}></i>
        </div>
        <div className="info-content">
          <h3>{title}</h3>
          <p className="m-0">{content}</p>
        </div>
      </div>
    </div>
  );
};

// Map Component
const ContactMap = () => {
  return (
    <div className="map rounded overflow-hidden mb-md-4">



<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5969.426205497726!2d74.161419!3d18.825984!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2d450d278d443%3A0x3652e75e36710498!2sAnand%20Krishi%20Paryatan%20Kendra%20Morachi%20Chincholi!5e1!3m2!1sen!2sin!4v1751967817335!5m2!1sen!2sin" width="1000" height="300"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>



      
    </div>
  );
};

// Contact Form Component
const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    comments: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "c425d721-8cf5-42a5-816e-e15f73734fc0");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <div id="contactform-error-msg">
      <form  onSubmit={onSubmit} method="post">
        <div className="form-group">
          <label htmlFor="first_name">First Name</label>
          <input
            type="text"
            id="first_name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="last_name">Last Name</label>
          <input
            type="text"
            id="last_name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="comments">Message</label>
          <textarea
            id="comments"
            name="comments"
            rows="5"
            value={formData.comments}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="form-group">
          <button type="submit">Send Message</button>
        </div>
      </form>
    </div>
  );
};

// Main Contact Section Component
const ContactSection = () => {
  return (




  <>




      <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
        <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
        <div className="breadcrumb-outer">
          <div className="container">
            <div className="breadcrumb-content text-center">
              <h2 className="mb-3 text-white">Contact Us</h2>
            </div>
          </div>
        </div>
        <div className="dot-overlay"></div>
      </section>





 


    <section className="contact-main pt-6 pb-60">
      <div className="container">
        <div className="contact-info-main mt-0">
          <div className="row">
            <div className="col-lg-10 col-offset-lg-1 mx-auto">
              <ContactInfo />
              <div id="contact-form1" className="contact-form">
                <div className="row">
                  <div className="col-lg-6">
                    <ContactMap />
                  </div>
                  <div className="col-lg-6">
                    <ContactForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default ContactSection;
